import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MF',
    quote: 'Incorporamos el tratado al estudio y dejó de ser necesario empezar cada demanda desde cero. Hoy resolvemos los casos con mucha más rapidez y seguridad.',
    name: 'Dra. María Ferreyra',
    role: 'Abogada Laboralista · Córdoba'
  }, {
    initials: 'JP',
    quote: 'Los modelos editables y la jurisprudencia organizada nos ahorran horas de trabajo todas las semanas. Se nota que fue elaborado por colegas que ejercen la profesión.',
    name: 'Dr. Juan Pérez',
    role: 'Estudio Jurídico · Buenos Aires'
  }, {
    initials: 'LG',
    quote: 'La inversión se recuperó con el primer expediente. Tener contratos, telegramas y escritos listos para adaptar hace una diferencia enorme.',
    name: 'Dra. Laura González',
    role: 'Abogada Litigante · Rosario'
  }];
  return <section className="mx-auto max-w-6xl px-5 py-14 md:px-8 md:py-20" data-id="element-182">
      <div className="mx-auto mb-9 max-w-2xl text-center" data-id="element-183">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-184">
          Experiencia profesional
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-185">
          Lo que dicen los abogados que ya lo utilizan
        </h2>
      </div>

      <div className="grid gap-5 md:grid-cols-3" data-id="element-186">
        {testimonials.map(testimonial => <article key={testimonial.name} className="border border-white/10 bg-charcoal p-6" data-id="element-187">
            <div className="flex items-center justify-between" data-id="element-188">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent font-bold text-ink" data-id="element-189">
                {testimonial.initials}
              </span>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-190">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} size={13} className="fill-accent text-accent" aria-hidden="true" data-id="element-191" />)}
              </div>
            </div>
            <blockquote className="mt-5 text-sm leading-relaxed text-stone-300" data-id="element-192">
              “{testimonial.quote}”
            </blockquote>
            <footer className="mt-6 border-t border-white/10 pt-4" data-id="element-193">
              <p className="text-sm font-bold text-white" data-id="element-194">{testimonial.name}</p>
              <p className="mt-1 text-xs text-stone-500" data-id="element-195">{testimonial.role}</p>
            </footer>
          </article>)}
      </div>
    </section>;
}